import React, { Component } from "react";
import AdminHeader from "../Header/AdminHeader";
import AdminFooter from "../Footer/AdminFooter";
import AdminLeftMenu from "../Navbar/AdminLeftMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faEdit,
  faEye,
  faEyeSlash,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import api from "../../axios/Axios";
import Alert from "../UI/Alert/Alert";
import Select from "react-select";
import { server } from "../../server";
import { HOST_URL, NODE_HOST_URL } from "../Dashboard/api/Api";
import Axios from "../../axios/Axios";
import EmptyImg from "../Dashboard/assets/img/create-project.png";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { userloginDetails } from "../Utils/AdminAuth";
import { faChevronDown, faChevronRight } from "@fortawesome/free-solid-svg-icons";
class EditEmployee extends Component {
  constructor() {
    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const empType = lStorage.user.isAdmin;
    const username = lStorage?.user?.username;


    super();

    this.state = {
      user_id: userId,
      token: userToken,
      emp_type: empType,
      username: username,
      successMessage: false,
      selectEmpDetails: "",
      errorMessage: "",
      bgColor: "alert alert-success alert-dismissible",
      emp_id: null,
      emp_token: "",
      name: "",
      mobile: "",
      email: "",
      password: "",
      cnfmPassword: "",
      employeeType: "",
      checkBox: {
        all: null,
        sms: null,
        voice: null,
        email: null,
        whatsapp: null,
        recharge: null,
        notification: null,
        rich_media: null,
        fallback: null,
        rcs: null,
        chat: null,
        flow: null
      },
      eyeIconToggle: false,
      passError: 0,
      updateEmployeeList: true,
      rcsPrice: false,
      _id: "",
      rcscountryCode: "",
      botid: "",
      basicrcscost: "",
      a2p_single_rcs_cost: "",
      a2p_conversation_cost: "",
      p2a_conversation_cost: "",
      margin: "",
      status: 1,
      frozen: 0,
      userBotId: [],
      rcsPriceList: [],
      selectedUserType: "",
      domain: "",
      isChecked: false,
      employeeList: [],
      parent: null,
      openMenu: {},
      expiryDate: "",
      updateExpirydate: "",
      SelecteddateFrom: "",
      permissionCheckBox: {
        all: false,
        usermanagement: false,
        userlist: false,
        userlistall: false,
        addnewclient: false,
        assignplan: false,
        empreseller: false,
        addeditprice: false,
        addeditcredit: false,
        transactiondetails: false,
        awssetting: false,
        billingmode: false,
        entitybypass: false,
        changecurrency: false,
        bulksmsroutesetting: false,
        autoshorturl: false,
        extrasetting: false,
        mmlite: false,
        routemanagement: false,
        routelist: false,
        routelistall: false,
        shiftrouter: false,
        changeroute: false,
        lcrroutesetting: false,
        embededsignup: false,
        read: false,
        edit: false,
        report: false,
        readreport: false,
        download: false,
        allreport: false,
        affiliatemanagement: false,
        affiliateuser: false,
        affiliatecommonlist: false,
        useractivity: false,
        loginhistory: false,
        signuphistory: false,
        entityhistory: false,
        sendorhistory: false,
        templatehistory: false,
        awssetuphistory: false,
        apirequest: false,
        invalidapirequest: false,
        setting: false,
        resellersetting: false,
        billingreport: false,
        billingreportall: false,
        vendorsummary: false,
        encryptionsetting: false,
        notificationsetting: false,
        crossorigin: false,
        addfaq: false,
        blog: false,
        feedback: false,
        contactus: false
      }
    };
    this.eyeToggle = this.eyeToggle.bind(this);
    this.handleCnfmPass = this.handleCnfmPass.bind(this);
    this.handlePass = this.handlePass.bind(this);
    this.handleCheckboxAll = this.handleCheckboxAll.bind(this);
    this.HandleEmployeeType = this.HandleEmployeeType.bind(this);
  }

  componentDidMount() {
    this.getRcsData();
    this.getBotid();
    this.getEmployee();

    this.setState({
      seletedUserId: this.props.match.params.id,
      selectedUserType: this.props.match.params.userType,
    });

    fetch(`${HOST_URL}/employee_user_list.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user_id: this.state.user_id,
        method: "userdetails",
        type: this.state.emp_type,
        ret_user_id: this.props.match.params.id,
        token: this.state.token,
        employee_type: this.props.match.params.userType,
      }),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success === true) {
          // const parentDtl = {
          //   label: result.data[0].parent_name,
          //   value: result.data[0].parent,
          // };
          this.setState({
            selectEmpDetails: result.data[0],
            name: result.data[0].fullname,
            email: result.data[0].email,
            mobile: result.data[0].mobile,
            emp_token: result.data[0].token,
            emp_id: result.data[0].id,
            employeeType: result.data[0].user_type,
            domain: result.data[0].domain_name,
            expiryDate: result.data[0].expiry,
            updateExpirydate: result.data[0].expiry,
            SelecteddateFrom: new Date(result.data[0].expiry),
            isChecked: result.data[0].postpaid == 1 ? true : false,
            // parent: parentDtl,
            parent: null,
            resellerId: result.data[0].reseller,
          });

          this.setState((prevState) => ({
            checkBox: {
              ...prevState.checkBox,
              sms: result.data[0].sms_menu,
              voice: result.data[0].voice_menu,
              email: result.data[0].email_menu,
              whatsapp: result.data[0].whatsapp_menu,
              recharge: result.data[0].rechrg_menu,
              notification: result.data[0].notify_menu,
              rich_media: result.data[0].rich_menu,
              fallback: result.data[0].fb_menu,
              rcs: result.data[0].rcs_menu,
              chat: result.data[0].chat_menu,
              flow: result.data[0].flow_menu,
            },
          }));

          if (
            result.data[0].sms_menu === 1 &&
            result.data[0].voice_menu === 1 &&
            result.data[0].email_menu === 1 &&
            result.data[0].whatsapp_menu === 1 &&
            result.data[0].rechrg_menu === 1 &&
            result.data[0].notify_menu === 1 &&
            result.data[0].rich_menu === 1 &&
            result.data[0].fb_menu === 1 &&
            result.data[0].rcs_menu === 1 &&
            result.data[0].chat_menu === 1 &&
            result.data[0].flow_menu === 1
          ) {
            this.setState((prevState) => ({
              checkBox: {
                ...prevState.checkBox,
                all: 1,
              },
            }));
          }
        } else {
          this.setState({
            successMessage: true,
            successBg: "alert alert-danger alert-dismissible",
            errorMessage: result.message,
          });
        }

        const permission = result.permission_values;

        this.setState({
          permissionCheckBox: {
            usermanagement: permission?.usermanagement?.enabled,
            userlist: permission?.usermanagement.children.userlist,
            userlistall: permission?.usermanagement.children.userlistall,
            addnewclient: permission?.usermanagement.children.addnewclient,
            assignplan: permission?.usermanagement.children.assignplan,
            empreseller: permission?.usermanagement.children.employeereseller,
            addeditprice: permission?.usermanagement.children.addeditprice,
            addeditcredit: permission?.usermanagement.children.addeditcredit,
            transactiondetails: permission?.usermanagement.children.transactiondetails,
            awssetting: permission?.usermanagement.children.awssettings,
            billingmode: permission?.usermanagement.children.billingmode,
            entitybypass: permission?.usermanagement.children.entitybypass,
            changecurrency: permission?.usermanagement.children.changecurrency,
            bulksmsroutesetting: permission?.usermanagement.children.bulksmsroutesetting,
            autoshorturl: permission?.usermanagement.children.autoshorturl,
            extrasetting: permission?.usermanagement.children.extrasettings,
            mmlite: permission?.usermanagement.children.mmlite,

            routemanagement: permission?.routemanagement.enabled,
            routelist: permission?.routemanagement.children.routelist,
            routelistall: permission?.routemanagement.children.routelistall,
            shiftrouter: permission?.routemanagement.children.shiftrouter,
            changeroute: permission?.routemanagement.children.changeroute,
            lcrroutesetting: permission?.routemanagement.children.lcrroutesetting,

            embededsignup: permission?.embeddedsignup.enabled,
            read: permission?.embeddedsignup.children.read,
            edit: permission?.embeddedsignup.children.edit,

            report: permission?.report.enabled,
            readreport: permission?.report.children.read,
            download: permission?.report.children.download,
            allreport: permission?.report.children.allreport,

            affiliatemanagement: permission?.affiliatemanagement.enabled,
            affiliateuser: permission?.affiliatemanagement.children.affiliateusers,
            affiliatecommonlist: permission?.affiliatemanagement.children.affiliatecommonlist,

            useractivity: permission?.useractivity.enabled,
            loginhistory: permission?.useractivity.children.loginhistory,
            signuphistory: permission?.useractivity.children.signuphistory,
            entityhistory: permission?.useractivity.children.entityhistory,
            sendorhistory: permission?.useractivity.children.sendorhistory,
            templatehistory: permission?.useractivity.children.templatehistory,
            awssetuphistory: permission?.useractivity.children.awssetuphistory,
            apirequest: permission?.useractivity.children.apirequest,
            invalidapirequest: permission?.useractivity.children.invalidapirequest,

            setting: permission?.setting.enabled,
            resellersetting: permission?.setting.children.resellersetting,

            billingreport: permission?.billingreport,
            billingreportall: permission?.billingreportall,
            vendorsummary: permission?.vendorsummary,
            encryptionsetting: permission?.encryptionsetting,
            notificationsetting: permission?.notificationsetting,
            crossorigin: permission?.crossorigin,
            addfaq: permission?.addfaq,
            blog: permission?.blog,
            feedback: permission?.feedback,
            contactus: permission?.contactus,
          },
        });

        if (
          permission?.usermanagement.enabled === true &&
          permission?.routemanagement.enabled === true &&
          permission?.embeddedsignup.enabled === true &&
          permission?.report.enabled === true &&
          permission?.affiliatemanagement.enabled === true &&
          permission?.useractivity.enabled === true &&
          permission?.setting.enabled === true &&
          permission?.billingreport === true &&
          permission?.vendorsummary === true &&
          permission?.encryptionsetting === true &&
          permission?.notificationsetting === true &&
          permission?.crossorigin === true &&
          permission?.addfaq === true &&
          permission?.blog === true &&
          permission?.feedback === true &&
          permission?.contactus === true
        ) {
          this.setState((prevState) => ({
            permissionCheckBox: {
              ...prevState.permissionCheckBox,
              all: true,
            },
          }));
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.successMessage !== this.state.successMessage) {
      if (this.state.successMessage === true) {
        this.interval = setInterval(() => {
          this.setState({
            successMessage: false,
          });
        }, 5000);
      }
    }
  }

  handlePermissionCheckboxAll = (e) => {
    const Pervalue = e.target.checked;

    this.setState({
      permissionCheckBox: {
        all: Pervalue,
        usermanagement: Pervalue,
        userlist: Pervalue,
        addnewclient: Pervalue,
        assignplan: Pervalue,
        empreseller: Pervalue,
        addeditprice: Pervalue,
        addeditcredit: Pervalue,
        transactiondetails: Pervalue,
        awssetting: Pervalue,
        billingmode: Pervalue,
        entitybypass: Pervalue,
        changecurrency: Pervalue,
        bulksmsroutesetting: Pervalue,
        autoshorturl: Pervalue,
        extrasetting: Pervalue,
        mmlite: Pervalue,
        routemanagement: Pervalue,
        routelist: Pervalue,
        shiftrouter: Pervalue,
        changeroute: Pervalue,
        lcrroutesetting: Pervalue,
        embededsignup: Pervalue,
        read: Pervalue,
        edit: Pervalue,
        report: Pervalue,
        readreport: Pervalue,
        download: Pervalue,
        allreport: Pervalue,
        affiliatemanagement: Pervalue,
        affiliateuser: Pervalue,
        affiliatecommonlist: Pervalue,
        useractivity: Pervalue,
        loginhistory: Pervalue,
        signuphistory: Pervalue,
        entityhistory: Pervalue,
        sendorhistory: Pervalue,
        templatehistory: Pervalue,
        awssetuphistory: Pervalue,
        apirequest: Pervalue,
        invalidapirequest: Pervalue,
        setting: Pervalue,
        resellersetting: Pervalue,
        billingreport: Pervalue,
        vendorsummary: Pervalue,
        encryptionsetting: Pervalue,
        notificationsetting: Pervalue,
        crossorigin: Pervalue,
        addfaq: Pervalue,
        blog: Pervalue,
        feedback: Pervalue,
        contactus: Pervalue
      }
    });
  };

  handlePermissionCheckbox = (e) => {
    const { name, checked } = e.target;

    this.setState((prevState) => {
      const updatedPermissions = {
        ...prevState.permissionCheckBox,
        [name]: checked,
      };

      // Check if all permissions except "all" are true
      const allChecked = Object.keys(updatedPermissions)
        .filter(key => key !== "all")
        .every(key => updatedPermissions[key] === true);

      updatedPermissions.all = allChecked;

      return {
        permissionCheckBox: updatedPermissions,
      };
    });
  };

  handlePermissionCheckboxAll = (e) => {
    const Pervalue = e.target.checked;

    this.setState({
      permissionCheckBox: {
        all: Pervalue,
        usermanagement: Pervalue,
        userlist: Pervalue,
        addnewclient: Pervalue,
        assignplan: Pervalue,
        empreseller: Pervalue,
        addeditprice: Pervalue,
        addeditcredit: Pervalue,
        transactiondetails: Pervalue,
        awssetting: Pervalue,
        billingmode: Pervalue,
        entitybypass: Pervalue,
        changecurrency: Pervalue,
        bulksmsroutesetting: Pervalue,
        autoshorturl: Pervalue,
        extrasetting: Pervalue,
        mmlite: Pervalue,
        routemanagement: Pervalue,
        routelist: Pervalue,
        shiftrouter: Pervalue,
        changeroute: Pervalue,
        lcrroutesetting: Pervalue,
        embededsignup: Pervalue,
        read: Pervalue,
        edit: Pervalue,
        report: Pervalue,
        readreport: Pervalue,
        download: Pervalue,
        affiliatemanagement: Pervalue,
        affiliateuser: Pervalue,
        affiliatecommonlist: Pervalue,
        useractivity: Pervalue,
        loginhistory: Pervalue,
        signuphistory: Pervalue,
        entityhistory: Pervalue,
        sendorhistory: Pervalue,
        templatehistory: Pervalue,
        awssetuphistory: Pervalue,
        apirequest: Pervalue,
        invalidapirequest: Pervalue,
        setting: Pervalue,
        resellersetting: Pervalue,
        billingreport: Pervalue,
        vendorsummary: Pervalue,
        encryptionsetting: Pervalue,
        notificationsetting: Pervalue,
        crossorigin: Pervalue,
        addfaq: Pervalue,
        blog: Pervalue,
        feedback: Pervalue,
        contactus: Pervalue
      }
    });
  };

  handlePermissionCheckbox = (e) => {
    const { name, checked } = e.target;

    this.setState((prevState) => {
      const updatedPermissions = {
        ...prevState.permissionCheckBox,
        [name]: checked,
      };

      // Check if all permissions except "all" are true
      const allChecked = Object.keys(updatedPermissions)
        .filter(key => key !== "all")
        .every(key => updatedPermissions[key] === true);

      updatedPermissions.all = allChecked;

      return {
        permissionCheckBox: updatedPermissions,
      };
    });
  };

  handleCheckboxChange = (event) => {
    this.setState({ isChecked: event.target.checked })
  };

  handleCheckbox = (e) => {
    const { name, checked } = e.target;
    let value;
    if (checked === true) {
      value = 1;
    } else {
      value = 0;
    }
    this.setState((prevState) => ({
      checkBox: {
        ...prevState.checkBox,
        [name]: value,
      },
    }));
  };

  eyeToggle(e) {
    e.preventDefault();
    this.setState((prevState) => ({
      eyeIconToggle: !prevState.eyeIconToggle,
    }));
  }

  handlePass(e) {
    this.setState({
      password: e.target.value,
    });
    if (e.target.value === "" && this.state.cnfmPassword === "")
      this.setState({
        passError: 0,
      });
  }

  handleCnfmPass(e) {
    if (e.target.value === "" && this.state.password === "")
      this.setState({
        passError: 0,
      });

    if (this.state.password === "") {
      return;
    } else {
      this.setState({
        passError: 1,
      });
    }
    const pass = this.state.password;
    const cnfmPass = e.target.value;
    this.setState({
      cnfmPassword: e.target.value,
    });
    if (pass === cnfmPass) {
      this.setState({
        passError: 0,
      });
    } else {
      this.setState({
        passError: 1,
      });
    }
  }
  handleCheckboxAll(e) {
    const { checked } = e.target;
    let value;
    if (checked === true) {
      value = 1;
    } else {
      value = 0;
    }
    this.setState((prevState) => ({
      checkBox: {
        ...prevState.checkBox,
        all: value,
        sms: value,
        voice: value,
        email: value,
        whatsapp: value,
        recharge: value,
        notification: value,
        rich_media: value,
        fallback: value,
        rcs: value,
        chat: value,
        flow: value
      },
    }));
  }

  HandleEmployeeType(e) {
    this.setState({
      employeeType: e.target.value,
    });
  }
  getEmployee() {
    fetch(
      `${server}/api/employee_user_list.php?user_id=${this.state.user_id}&method=retrieve&type=${this.state.emp_type}&token=${this.state.token}`
    ).then((response) => {
      response.json().then((result) => {
        //  console.log(result);
        if (result.success === true) {
          const formattedUsers = result.data.map((user) => ({
            value: user.id,
            label: user.fullname,
          }));
          // this.setState({
          //   employeeList: formattedUsers,
          // });
          this.setState({
            employeeList: formattedUsers,
          }, () => {
            if (this.state.emp_type === "reseller") {
              this.setState({ parent: { label: this.state.username, value: this.state.user_id } });
            } else if (this.state.resellerId == 1) {
              this.setState({ parent: { value: 1, label: "admin@datagenit.com" } });
            } else {
              const parentObj = formattedUsers.find(
                (emp) => emp.value == this.state.resellerId
              );
              if (parentObj) {
                this.setState({ parent: parentObj });
              }
            }
          });
        } else {
          this.setState({
            successMessage: true,
            bgColor: "alert alert-danger alert-dismissible",
            errorMessage: result.message,
          });
        }
      });
    });
  }

  buildSubAdminPayload = (permissionCheckBox) => {
    return {
      role: "sub_admin",
      fullAccess: this.state.permissionCheckBox.all || false,
      permissions: {

        usermanagement: {
          enabled: this.state.permissionCheckBox.usermanagement,
          children: {
            userlist: this.state.permissionCheckBox.userlist,
            userlistall: this.state.permissionCheckBox.userlistall,
            addnewclient: this.state.permissionCheckBox.addnewclient,
            assignplan: this.state.permissionCheckBox.assignplan,
            employeereseller: this.state.permissionCheckBox.empreseller,
            addeditprice: this.state.permissionCheckBox.addeditprice,
            addeditcredit: this.state.permissionCheckBox.addeditcredit,
            transactiondetails: this.state.permissionCheckBox.transactiondetails,
            awssettings: this.state.permissionCheckBox.awssetting,
            billingmode: this.state.permissionCheckBox.billingmode,
            entitybypass: this.state.permissionCheckBox.entitybypass,
            changecurrency: this.state.permissionCheckBox.changecurrency,
            bulksmsroutesetting: this.state.permissionCheckBox.bulksmsroutesetting,
            autoshorturl: this.state.permissionCheckBox.autoshorturl,
            extrasettings: this.state.permissionCheckBox.extrasetting,
            mmlite: this.state.permissionCheckBox.mmlite
          }
        },

        routemanagement: {
          enabled: this.state.permissionCheckBox.routemanagement,
          children: {
            routelist: this.state.permissionCheckBox.routelist,
            routelistall: this.state.permissionCheckBox.routelistall,
            shiftrouter: this.state.permissionCheckBox.shiftrouter,
            changeroute: this.state.permissionCheckBox.changeroute,
            lcrroutesetting: this.state.permissionCheckBox.lcrroutesetting
          }
        },

        embeddedsignup: {
          enabled: this.state.permissionCheckBox.embededsignup,
          children: {
            read: this.state.permissionCheckBox.read,
            edit: this.state.permissionCheckBox.edit
          }
        },

        report: {
          enabled: this.state.permissionCheckBox.report,
          children: {
            read: this.state.permissionCheckBox.readreport,
            download: this.state.permissionCheckBox.download,
            allreport: this.state.permissionCheckBox.allreport
          }
        },

        affiliatemanagement: {
          enabled: this.state.permissionCheckBox.affiliatemanagement,
          children: {
            affiliateusers: this.state.permissionCheckBox.affiliateuser,
            affiliatecommonlist: this.state.permissionCheckBox.affiliatecommonlist
          }
        },

        useractivity: {
          enabled: this.state.permissionCheckBox.useractivity,
          children: {
            loginhistory: this.state.permissionCheckBox.loginhistory,
            signuphistory: this.state.permissionCheckBox.signuphistory,
            entityhistory: this.state.permissionCheckBox.entityhistory,
            sendorhistory: this.state.permissionCheckBox.sendorhistory,
            templatehistory: this.state.permissionCheckBox.templatehistory,
            awssetuphistory: this.state.permissionCheckBox.awssetuphistory,
            apirequest: this.state.permissionCheckBox.apirequest,
            invalidapirequest: this.state.permissionCheckBox.invalidapirequest
          }
        },

        setting: {
          enabled: this.state.permissionCheckBox.setting,
          children: {
            resellersetting: this.state.permissionCheckBox.resellersetting
          }
        },

        billingreport: this.state.permissionCheckBox.billingreport,
        billingreportall: this.state.permissionCheckBox.billingreportall,
        vendorsummary: this.state.permissionCheckBox.vendorsummary,
        encryptionsetting: this.state.permissionCheckBox.encryptionsetting,
        notificationsetting: this.state.permissionCheckBox.notificationsetting,
        crossorigin: this.state.permissionCheckBox.crossorigin,
        addfaq: this.state.permissionCheckBox.addfaq,
        blog: this.state.permissionCheckBox.blog,
        feedback: this.state.permissionCheckBox.feedback,
        contactus: this.state.permissionCheckBox.contactus
      }
    };
  };


  buildSubAdminPayload = (permissionCheckBox) => {
    return {
      role: "sub_admin",
      fullAccess: this.state.permissionCheckBox.all || false,
      permissions: {

        usermanagement: {
          enabled: this.state.permissionCheckBox.usermanagement,
          children: {
            userlist: this.state.permissionCheckBox.userlist,
            addnewclient: this.state.permissionCheckBox.addnewclient,
            assignplan: this.state.permissionCheckBox.assignplan,
            employeereseller: this.state.permissionCheckBox.empreseller,
            addeditprice: this.state.permissionCheckBox.addeditprice,
            addeditcredit: this.state.permissionCheckBox.addeditcredit,
            transactiondetails: this.state.permissionCheckBox.transactiondetails,
            awssettings: this.state.permissionCheckBox.awssetting,
            billingmode: this.state.permissionCheckBox.billingmode,
            entitybypass: this.state.permissionCheckBox.entitybypass,
            changecurrency: this.state.permissionCheckBox.changecurrency,
            bulksmsroutesetting: this.state.permissionCheckBox.bulksmsroutesetting,
            autoshorturl: this.state.permissionCheckBox.autoshorturl,
            extrasettings: this.state.permissionCheckBox.extrasetting,
            mmlite: this.state.permissionCheckBox.mmlite
          }
        },

        routemanagement: {
          enabled: this.state.permissionCheckBox.routemanagement,
          children: {
            routelist: this.state.permissionCheckBox.routelist,
            shiftrouter: this.state.permissionCheckBox.shiftrouter,
            changeroute: this.state.permissionCheckBox.changeroute,
            lcrroutesetting: this.state.permissionCheckBox.lcrroutesetting
          }
        },

        embeddedsignup: {
          enabled: this.state.permissionCheckBox.embededsignup,
          children: {
            read: this.state.permissionCheckBox.read,
            edit: this.state.permissionCheckBox.edit
          }
        },

        report: {
          enabled: this.state.permissionCheckBox.report,
          children: {
            read: this.state.permissionCheckBox.readreport,
            download: this.state.permissionCheckBox.download
          }
        },

        affiliatemanagement: {
          enabled: this.state.permissionCheckBox.affiliatemanagement,
          children: {
            affiliateusers: this.state.permissionCheckBox.affiliateuser,
            affiliatecommonlist: this.state.permissionCheckBox.affiliatecommonlist
          }
        },

        useractivity: {
          enabled: this.state.permissionCheckBox.useractivity,
          children: {
            loginhistory: this.state.permissionCheckBox.loginhistory,
            signuphistory: this.state.permissionCheckBox.signuphistory,
            entityhistory: this.state.permissionCheckBox.entityhistory,
            sendorhistory: this.state.permissionCheckBox.sendorhistory,
            templatehistory: this.state.permissionCheckBox.templatehistory,
            awssetuphistory: this.state.permissionCheckBox.awssetuphistory,
            apirequest: this.state.permissionCheckBox.apirequest,
            invalidapirequest: this.state.permissionCheckBox.invalidapirequest
          }
        },

        setting: {
          enabled: this.state.permissionCheckBox.setting,
          children: {
            resellersetting: this.state.permissionCheckBox.resellersetting
          }
        },

        billingreport: this.state.permissionCheckBox.billingreport,
        vendorsummary: this.state.permissionCheckBox.vendorsummary,
        encryptionsetting: this.state.permissionCheckBox.encryptionsetting,
        notificationsetting: this.state.permissionCheckBox.notificationsetting,
        crossorigin: this.state.permissionCheckBox.crossorigin,
        addfaq: this.state.permissionCheckBox.addfaq,
        blog: this.state.permissionCheckBox.blog,
        feedback: this.state.permissionCheckBox.feedback,
        contactus: this.state.permissionCheckBox.contactus
      }
    };
  };

  updateEmployedd = async () => {
    if (!this.state.name) {
      this.setState({
        successMessage: true,
        bgColor: "alert alert-danger alert-dismissible",
        errorMessage: "Please enter your name",
      });

      return;
    }
    if (!(this.state.cnfmPassword === this.state.password)) {
      this.setState({
        successMessage: true,
        bgColor: "alert alert-danger alert-dismissible",
        errorMessage: "The passwords you entered don't match",
      });

      return;
    }

    const subAdminPermission = this.buildSubAdminPayload(this.state.permissionCheckBox);

    const updateData = {
      id: this.state.emp_id,
      user_id: this.state.user_id,
      token: this.state.token,
      employee_type: this.state.employeeType,
      email: this.state.email,
      fullname: this.state.name,
      password: this.state.password,
      domain_name: this.state.domain,
      sms_menu: this.state.checkBox.sms,
      voice_menu: this.state.checkBox.voice,
      email_menu: this.state.checkBox.email,
      whatsapp_menu: this.state.checkBox.whatsapp,
      rechrg_menu: this.state.checkBox.recharge,
      notify_menu: this.state.checkBox.notification,
      rich_menu: this.state.checkBox.rich_media,
      fb_menu: this.state.checkBox.fallback,
      rcs_menu: this.state.checkBox.rcs,
      chat_menu: this.state.checkBox.chat,
      flow_menu: this.state.checkBox.flow,
      postpaid: this.state.isChecked ? 1 : 0,
      parent: this.state.parent?.value,
      expiry: this.state.updateExpirydate,
      permissionValue: subAdminPermission,
      method: "update_emp",
    };
    // const data= await axios.post(`${server}/employee_user_list.php`, updateData)
    const { data } = await api.post("/api/employee_user_list.php", updateData);

    if (data.success === true) {
      this.setState({
        successMessage: true,
        bgColor: "alert alert-success alert-dismissible",
        errorMessage: data.message,
      });
    }
    if (data.success === false) {
      this.setState({
        successMessage: true,
        bgColor: "alert alert-danger alert-dismissible",
        errorMessage: data.message,
      });
    }
  };

  getBotid = async () => {
    const senderParamData = {
      user_id: this.state.user_id,
      token: this.state.token,
      method: "userwise_bot",
      client_id: this.props.match.params.id,
    };
    try {
      let { data } = await Axios.post(
        `${NODE_HOST_URL}/admin/rcs`,
        senderParamData
      );
      if (data.success) {
        this.setState({
          userBotId: data.data,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  addRcsPrice = async () => {
    const paramData = {
      user_id: this.state.user_id,
      retr_user_id: this.props.match.params.id,
      token: this.state.token,
      method: "add_single_country_pricercs",
      country_code: this.state.rcscountryCode,
      bot_id: this.state.botid || "12345",
      margin: parseFloat(this.state.margin),
      parent_type: this.state.emp_type,
      client_type: this.props.match.params.userType,
      is_frozen: this.state.frozen,
      is_active: this.state.status,
    };
    try {
      let { data } = await Axios.post(
        `${NODE_HOST_URL}/rcs_setting`,
        paramData
      );
      if (data) {
        this.setState({
          successMessage: true,
          bgColor: "alert alert-success alert-dismissible",
          errorMessage: data.message,
        });
        setTimeout(() => {
          this.setState({ successMessage: false });
        }, 4000);
        this.getRcsData();
        this.setState({
          rcscountryCode: "",
          botid: "",
          margin: "",
          _id: "",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  getRcsData = async () => {
    const retrieveParam = {
      user_id: this.state.user_id,
      userId: this.props.match.params.id,
      token: this.state.token,
      method: "retrieve_price",
    };
    try {
      let { data } = await Axios.post(
        `${NODE_HOST_URL}/rcs_setting`,
        retrieveParam
      );
      if (data.success) {
        this.setState({ rcsPriceList: data.data });
      }
    } catch (error) {
      console.log(error);
    }
  };

  getRcsPrice = (
    id,
    countrycode,
    botid,
    rcscost,
    a2pcost,
    a2pconvcost,
    p2acost
  ) => {
    this.setState({
      _id: id,
      rcscountryCode: countrycode,
      botid: botid,
      basicrcscost: rcscost,
      a2p_single_rcs_cost: a2pcost,
      a2p_conversation_cost: a2pconvcost,
      p2a_conversation_cost: p2acost,
    });
  };

  updateRcsPrice = async () => {
    const paramupdateData = {
      user_id: this.state.user_id,
      token: this.state.token,
      retr_user_id: this.props.match.params.id,
      bot_id: this.state.botid || "12345",
      country_code: this.state.rcscountryCode,
      basic_sms_cost: parseFloat(this.state.basicrcscost),
      p2a_conv_cost: parseFloat(this.state.p2a_conversation_cost),
      a2p_conv_cost: parseFloat(this.state.a2p_conversation_cost),
      a2p_single_sms_cost: parseFloat(this.state.a2p_single_rcs_cost),
      method: "update_rcsprice",
      parent_type: this.state.emp_type,
      client_type: this.props.match.params.userType,
    };
    try {
      let { data } = await Axios.post(
        `${NODE_HOST_URL}/rcs_setting`,
        paramupdateData
      );
      if (data.success) {
        this.setState({
          successMessage: true,
          bgColor: "alert alert-success alert-dismissible",
          errorMessage: data.message,
        });
        setTimeout(() => {
          this.setState({ successMessage: false });
        }, 4000);
        this.getRcsData();
      }
    } catch (error) {
      console.log(error);
    }
  };

  // updateRcsPriceNew =async () =>{
  //   const paramupdateData = {
  //     user_id: this.state.user_id,
  //     token: this.state.token,
  //     retr_user_id: this.props.match.params.id,
  //     bot_id: "4467895",
  //     country_code: this.state.rcscountryCode,
  //     basic_sms_cost: parseFloat(this.state.basicrcscost),
  //     p2a_conv_cost: parseFloat(this.state.p2a_conversation_cost),
  //     a2p_conv_cost: parseFloat(this.state.a2p_conversation_cost),
  //     a2p_single_sms_cost: parseFloat(this.state.a2p_single_rcs_cost),
  //     method: "update_rcsprice",
  //     parent_type: this.state.emp_type,
  //     client_type: this.props.match.params.userType,
  //     sms_cost: 10,
  //     voice_cost: 9
  //   }
  //   try {
  //     let {data} = await Axios.post(`${NODE_HOST_URL}/rcs_setting`,paramupdateData);
  //     if(data.success){
  //       this.setState({
  //         successMessage: true,
  //         bgColor: "alert alert-success alert-dismissible",
  //         errorMessage: data.message,
  //       });
  //       setTimeout(() => {
  //         this.setState({ successMessage: false })
  //       }, 4000)
  //       this.getRcsData();
  //     }
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }

  toggleMenu = (index) => {
    this.setState((prevState) => ({
      openMenu: {
        ...prevState.openMenu,
        [index]: !prevState.openMenu[index],
      },
    }));
  };

  renderCustomHeader = ({
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }) => {


    const years = [];
    for (let year = 1990; year <= 2050; year++) {
      years.push(year);
    }

    const months = [
      "January", "February", "March", "April", "May", "June", "July",
      "August", "September", "October", "November", "December",
    ];

    const handleDecreaseMonth = (event) => {
      event.preventDefault();
      decreaseMonth();
    };

    const handleIncreaseMonth = (event) => {
      event.preventDefault();
      increaseMonth();
    };

    return (
      <div style={{ margin: 10, display: "flex", justifyContent: "center" }}>
        <button
          onClick={handleDecreaseMonth}
          disabled={prevMonthButtonDisabled}
          style={{ borderStyle: "none" }}
        >
          {"<"}
        </button>

        <select
          value={date.getFullYear()}
          onChange={({ target: { value } }) => changeYear(Number(value))}
          style={{ borderStyle: "groove", marginRight: "2px", cursor: "pointer", width: "6em" }}
        >
          {years.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>

        <select
          value={months[date.getMonth()]}
          onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}
          style={{ borderStyle: "groove", marginRight: "2px", cursor: "pointer" }}
        >
          {months.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>

        <button
          onClick={handleIncreaseMonth}
          disabled={nextMonthButtonDisabled}
          style={{ borderStyle: "none" }}
        >
          {">"}
        </button>
      </div>
    );
  };

  dateFrom = (date) => {
    let dated =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      ("0" + date.getDate()).slice(-2);
    if (this.state.user_id == 4784 || this.state.userType === "reseller" || "admin") {
      this.setState({
        expiryDate: dated,
        updateExpirydate: dated,
        SelecteddateFrom: date,
      });
    }
  };

  render() {
    return (
      <div className="wrapper">
        <AdminLeftMenu />
        <div className="main">
          <AdminHeader />
          <main className="content">
            <div className="container-fluid p-0">
              {this.state.successMessage && (
                <Alert type={this.state.bgColor}>
                  {this.state.errorMessage}
                </Alert>
              )}
              <div className="row mb-2 mb-xl-3">
                <div className="col-auto d-none d-sm-block">
                  <h3>
                    <strong> Edit </strong> Employee{" "}
                  </h3>
                </div>
              </div>
              <div className="row">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <div className="col-auto ml-auto text-right mt-n1">
                        <nav className="text-center" aria-label="breadcrumb">
                          <ol className="breadcrumb bg-transparent p-0 mt-1 mb-0">
                            <Link
                              to={
                                "/admin/edit-employee/" +
                                this.state.seletedUserId +
                                `/` +
                                this.state.selectedUserType
                              }
                            >
                              <li className="breadcrumb-item active">
                                Update Details{" "}
                              </li>{" "}
                            </Link>
                            <Link
                              to={
                                "/admin/reseller-transaction-details/" +
                                this.state.seletedUserId +
                                `/` +
                                this.state.selectedUserType
                              }
                            >
                              {" "}
                              <li className="breadcrumb-item">
                                {" "}
                                Transaction Details{" "}
                              </li>
                            </Link>

                            <Link
                              to={
                                "/admin/reseller-price-details/" +
                                this.state.seletedUserId +
                                `/` +
                                this.state.selectedUserType + `?channel=whatsapp`
                              }
                            >
                              <li className="breadcrumb-item"> Add Price </li>
                            </Link>

                            <Link
                              to={
                                "/admin/reseller-add-price/" +
                                this.state.seletedUserId +
                                `/` +
                                this.state.selectedUserType
                              }
                            >
                              {" "}
                              <li className="breadcrumb-item">
                                {" "}
                                Add Credit{" "}
                              </li>
                            </Link>

                            <Link
                              to={
                                "/admin/reseller-billing-mode/" +
                                this.state.seletedUserId +
                                `/` +
                                this.state.selectedUserType
                              }
                            >
                              {" "}
                              <li className="breadcrumb-item">
                                {" "}
                                Billing Mode{" "}
                              </li>
                            </Link>
                          </ol>
                        </nav>
                      </div>
                    </h5>
                  </div>
                  <div className="card-body">
                    {this.state.updateEmployeeList && (
                      <div className="row">
                        <div className="col-12 col-lg-12 col-xxl-12 d-flex">
                          <div className=" flex-fill">
                            <form>
                              <div className="row">
                                <div className="mb-3 col-md-6">
                                  <label
                                    className="form-label"
                                    htmlFor="inputFirstName"
                                  >
                                    Employee type
                                  </label>
                                  <select
                                    onChange={this.HandleEmployeeType}
                                    className="form-control cursor-pointer"
                                  >
                                    <option value="">Select Employee</option>
                                    <option
                                      selected={
                                        this.state.employeeType === "subadmin"
                                          ? true
                                          : false
                                      }
                                      value={"subadmin"}
                                    >
                                      Sub Admin
                                    </option>
                                    <option
                                      selected={
                                        this.state.employeeType === "emp"
                                          ? true
                                          : false
                                      }
                                      value={"emp"}
                                    >
                                      Employee
                                    </option>
                                    <option
                                      selected={
                                        this.state.employeeType === "reseller"
                                          ? true
                                          : false
                                      }
                                      value={"reseller"}
                                    >
                                      Reseller
                                    </option>
                                  </select>
                                </div>

                                <div className="mb-3 col-md-6">
                                  <label
                                    className="form-label"
                                    htmlFor="inputFirstName"
                                  >
                                    Full Name
                                  </label>
                                  <input
                                    type="text"
                                    defaultValue={this.state.name}
                                    onChange={(event) =>
                                      this.setState({
                                        name: event.target.value,
                                      })
                                    }
                                    className="form-control"
                                    placeholder="Enter Full Name"
                                    required
                                  />
                                </div>
                                <div
                                  className="mb-3 col-md-6 cursor-no-drop
"
                                >
                                  <label
                                    className="form-label"
                                    htmlFor="inputEmail4"
                                  >
                                    Email
                                  </label>
                                  <input
                                    readOnly
                                    type="email"
                                    defaultValue={this.state.email}
                                    className="form-control cursor-no-drop
                                  "
                                    placeholder="Email"
                                    disabled
                                  />
                                </div>

                                <div className="mb-3 col-md-6">
                                  <label
                                    className="form-label"
                                    htmlFor="inputFirstName"
                                  >
                                    Enter Mobile Number
                                  </label>
                                  <input
                                    readOnly
                                    type="text"
                                    defaultValue={this.state.mobile}
                                    onChange={(event) =>
                                      this.setState({
                                        mobile: event.target.value,
                                      })
                                    }
                                    className="form-control"
                                    placeholder="Enter 10 Digit Mobile Number"
                                    disabled
                                  />
                                </div>
                              </div>
                              <div className="row">
                                <div className="mb-3 col-md-6">
                                  <label
                                    className="form-label"
                                    htmlFor="inputFirstName"
                                  >
                                    Password
                                  </label>
                                  <div className="d-flex flex-row">
                                    <input
                                      type={
                                        this.state.eyeIconToggle === true
                                          ? "text"
                                          : "password"
                                      }
                                      defaultValue={this.state.password}
                                      onChange={this.handlePass}
                                      className="form-control"
                                      placeholder="Enter new password"
                                      required
                                    />

                                    <button
                                      className="border-0 "
                                      onClick={this.eyeToggle}
                                    >
                                      {this.state.eyeIconToggle === true ? (
                                        <FontAwesomeIcon icon={faEyeSlash} />
                                      ) : (
                                        <FontAwesomeIcon icon={faEye} />
                                      )}
                                    </button>
                                  </div>
                                </div>

                                <div className="mb-3 col-md-6">
                                  <label
                                    className="form-label"
                                    htmlFor="inputFirstName"
                                  >
                                    Confirm Password
                                  </label>
                                  <div className="d-flex flex-row">
                                    <input
                                      type={
                                        this.state.eyeIconToggle === true
                                          ? "text"
                                          : "password"
                                      }
                                      defaultValue={this.state.cnfmPassword}
                                      onChange={this.handleCnfmPass}
                                      className="form-control"
                                      placeholder="Enter new password"
                                      required
                                    />
                                    <button
                                      className="border-0 "
                                      onClick={this.eyeToggle}
                                    >
                                      {this.state.eyeIconToggle === true ? (
                                        <FontAwesomeIcon icon={faEyeSlash} />
                                      ) : (
                                        <FontAwesomeIcon icon={faEye} />
                                      )}
                                    </button>
                                  </div>

                                  {this.state.passError === 1 && (
                                    <p
                                      className="text-danger"
                                      style={{ fontSize: "10px" }}
                                    >
                                      *The passwords you entered don't match
                                    </p>
                                  )}
                                </div>
                              </div>
                              <div className="row">
                                {this.state.employeeType === "reseller" && <div className="mb-3 col-md-6">
                                  <label className="form-label">Domain <small>(*Note:- Enter domain without https:// or http://)</small></label>

                                  <input
                                    type={"text"}
                                    value={this.state.domain}
                                    onChange={(e) => this.setState({ domain: e.target.value })}
                                    className="form-control"
                                    placeholder="Enter your domain"

                                  />
                                </div>}

                                {this.state.emp_type === "admin" &&
                                  <div className="mb-3 col-md-6">
                                    <label>
                                      <input
                                        type="checkbox"
                                        checked={this.state.isChecked}
                                        onChange={this.handleCheckboxChange}
                                        className="mt-5"
                                      />
                                      <span className="ml-1">Postpaid</span>
                                    </label>
                                  </div>}
                              </div>
                              
                              <div className="row">
                                <div className="mb-3 col-md-4">
                                  <label
                                    className="form-label"
                                    htmlFor="inputCity"
                                  >
                                    Select Parent
                                  </label>



                                  <Select
                                    onChange={(selectedOption) =>
                                      this.setState({
                                        parent: selectedOption,
                                      })
                                    }
                                    options={this.state.employeeList}
                                    value={this.state.emp_type === "reseller" ? { label: this.state.username, value: this.state.user_id } : this.state.parent}
                                    isSearchable={true}
                                    placeholder="Select Parent"
                                    isClearable={this.state.emp_type !== "reseller"}
                                    isDisabled={this.state.emp_type === "reseller"}
                                    styles={this.customStyles}
                                  />
                                </div>

                                <div className="col-md-4">
                                  <label
                                    className="form-label "
                                    htmlFor="inputCity"
                                  >
                                    Extend Reseller validity{" "}
                                  </label>
                                  <div className="input-group mb-2 ">
                                    <div className="input-group-text">
                                      <FontAwesomeIcon icon={faCalendarAlt} />
    </div>
    <div style={{flex: 1}}>
                                    <DatePicker
                                      className={`form-control btn-block `}
                                      dateFormat="yyyy-MM-dd"
                                      renderCustomHeader={this.renderCustomHeader}
                                      // value={this.state.expiryDate}
                                      onChange={this.dateFrom}
                                      selected={this.state.SelecteddateFrom}
                                      placeholderText="From Date"

                                      disabled={this.state.employeeType === "reseller" || "admin" ? false : true}
                                    />
                                 </div>
                              
                                  </div>
                                </div>
                              </div>
  

                              <div style={{ marginTop: "20px" }}>                          
                                  <div className="row mt-3">
                                    <div className="col-4">
                                      <h6>Channels</h6>
                                    </div>
                                  </div>

                              
                                <div
                                  style={{
                                    border: "1px solid #e5e5e5",
                                    borderRadius: "8px",
                                    padding: "15px",
                                    marginTop: "8px"
                                  }}
                                >
                                      <div className="row ml-2">
                                        <div className="form-check col-md-2">
                                          <input
                                            className="form-check-input cursor-pointer
                                  "
                                        type="checkbox"
                                        checked={
                                          this.state.checkBox.all === 1
                                            ? true
                                            : false
                                        }
                                        name="all"
                                        value={this.state.checkBox.all}
                                        onChange={this.handleCheckboxAll}
                                      />
                                      <label
                                        className="form-check-label"
                                        for="flexCheckDefault"
                                      >
                                        All
                                      </label>
                                    </div>

                                    <div className="form-check col-md-2">
                                      <input
                                        className="form-check-input cursor-pointer
                                  "
                                        type="checkbox"
                                        checked={
                                          this.state.checkBox.sms === 1
                                            ? true
                                            : false
                                        }
                                        name="sms"
                                        value={this.state.checkBox.sms}
                                        onChange={this.handleCheckbox}
                                        id="flexCheckDefault"
                                      />
                                      <label
                                        className="form-check-label"
                                        for="flexCheckDefault"
                                      >
                                        SMS
                                      </label>
                                    </div>

                                    <div className="form-check col-md-2">
                                      <input
                                        className="form-check-input cursor-pointer
                                  "
                                        type="checkbox"
                                        name="voice"
                                        checked={
                                          this.state.checkBox.voice === 1
                                            ? true
                                            : false
                                        }
                                        value={this.state.checkBox.voice}
                                        onChange={this.handleCheckbox}
                                      />
                                      <label
                                        className="form-check-label"
                                        for="flexCheckDefault"
                                      >
                                        Voice
                                      </label>
                                    </div>

                                    <div className="form-check col-md-2">
                                      <input
                                        className="form-check-input cursor-pointer
                                  "
                                        type="checkbox"
                                        value={this.state.checkBox.email}
                                        checked={
                                          this.state.checkBox.email === 1
                                            ? true
                                            : false
                                        }
                                        name="email"
                                        onChange={this.handleCheckbox}
                                      />
                                      <label
                                        className="form-check-label"
                                        for="flexCheckDefault"
                                      >
                                        Email
                                      </label>
                                    </div>

                                    <div className="form-check col-md-2">
                                      <input
                                        className="form-check-input cursor-pointer
                                  "
                                        type="checkbox"
                                        name="whatsapp"
                                        value={this.state.checkBox.whatsapp}
                                        checked={
                                          this.state.checkBox.whatsapp === 1
                                            ? true
                                            : false
                                        }
                                        onChange={this.handleCheckbox}
                                      />
                                      <label
                                        className="form-check-label"
                                        for="flexCheckDefault"
                                      >
                                        Whatsapp
                                      </label>
                                    </div>

                                    <div className="form-check col-md-2">
                                      <input
                                        className="form-check-input cursor-pointer
                                  "
                                        type="checkbox"
                                        name="recharge"
                                        value={this.state.checkBox.recharge}
                                        checked={
                                          this.state.checkBox.recharge === 1
                                            ? true
                                            : false
                                        }
                                        onChange={this.handleCheckbox}
                                      />
                                      <label
                                        className="form-check-label"
                                        for="flexCheckDefault"
                                      >
                                        Recharge
                                      </label>
                                    </div>

                                    <div className="form-check col-md-2">
                                      <input
                                        className="form-check-input cursor-pointer
                                  "
                                        type="checkbox"
                                        name="notification"
                                        value={this.state.checkBox.notification}
                                        checked={
                                          this.state.checkBox.notification === 1
                                            ? true
                                            : false
                                        }
                                        onChange={this.handleCheckbox}
                                      />
                                      <label
                                        className="form-check-label"
                                        for="flexCheckDefault"
                                      >
                                        Notification
                                      </label>
                                    </div>

                                    <div className="form-check col-md-2">
                                      <input
                                        className="form-check-input cursor-pointer
                                  "
                                        type="checkbox"
                                        name="rich_media"
                                        value={this.state.checkBox.rich_media}
                                        checked={
                                          this.state.checkBox.rich_media === 1
                                            ? true
                                            : false
                                        }
                                        onChange={this.handleCheckbox}
                                      />
                                      <label
                                        className="form-check-label"
                                        for="flexCheckDefault"
                                      >
                                        Rich Media
                                      </label>
                                    </div>

                                    <div className="form-check col-md-2">
                                      <input
                                        className="form-check-input cursor-pointer
                                  "
                                        type="checkbox"
                                        name="fallback"
                                        value={this.state.checkBox.fallback}
                                        checked={
                                          this.state.checkBox.fallback === 1
                                            ? true
                                            : false
                                        }
                                        onChange={this.handleCheckbox}
                                      />
                                      <label
                                        className="form-check-label"
                                        for="flexCheckDefault"
                                      >
                                        Fallback
                                      </label>
                                    </div>

                                        <div className="form-check col-md-2">
                                          <input
                                            className="form-check-input cursor-pointer"
                                            type="checkbox"
                                            name="rcs"
                                            value={this.state.checkBox.rcs}
                                            checked={
                                              this.state.checkBox.rcs === 1
                                                ? true
                                                : false
                                            }
                                            onChange={this.handleCheckbox}
                                          />
                                          <label
                                            className="form-check-label"
                                            for="flexCheckDefault"
                                          >
                                            RCS
                                          </label>
                                        </div>

                                    <div className="form-check col-md-2">
                                      <input
                                        className="form-check-input cursor-pointer
                                  "
                                        type="checkbox"
                                        name="chat"
                                        value={this.state.checkBox.chat}
                                        checked={
                                          this.state.checkBox.chat === 1
                                            ? true
                                            : false
                                        }
                                        onChange={this.handleCheckbox}
                                      />
                                      <label
                                        className="form-check-label"
                                        for="flexCheckDefault"
                                      >
                                        Chat
                                      </label>
                                    </div>

                                    <div className="form-check col-md-2">
                                      <input
                                        className="form-check-input cursor-pointer
                                  "
                                        type="checkbox"
                                        name="flow"
                                        value={this.state.checkBox.flow}
                                        checked={
                                          this.state.checkBox.flow === 1
                                            ? true
                                            : false
                                        }
                                        onChange={this.handleCheckbox}
                                      />
                                      <label
                                        className="form-check-label"
                                        for="flexCheckDefault"
                                      >
                                        Flow
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {this.state.employeeType === "subadmin" &&
                                <div style={{ marginTop: "25px" }}>
                                  <label style={{ fontWeight: "600" }}>
                                    Some Heading
                                    <input type="checkbox" style={{ marginLeft: "10px" }}
                                      value={this.state.permissionCheckBox.all}
                                      checked={this.state.permissionCheckBox.all}
                                      onChange={this.handlePermissionCheckboxAll} />
                                  </label>

                                  <div
                                    style={{
                                      border: "1px solid #e5e5e5",
                                      borderRadius: "8px",
                                      padding: "15px",
                                      marginTop: "8px",
                                    }}
                                  >
                                    <div className="row">

                                      {/* ===== BOX 1 ===== */}
                                      <div className="col-md-3 mb-3">
                                        <div
                                          className="form-check"
                                          style={{
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                          }}
                                        >
                                          <input className="form-check-input" type="checkbox" name="usermanagement"
                                            value={this.state.permissionCheckBox.usermanagement}
                                            checked={this.state.permissionCheckBox.usermanagement}
                                            onChange={this.handlePermissionCheckbox} />

                                          <label
                                            className="form-check-label"
                                            style={{ fontWeight: "500", marginBottom: 0, color: (this.state.openMenu[0] && this.state.permissionCheckBox.usermanagement) && "#F97316" }}
                                          >
                                            User Management
                                          </label>

                                          {this.state.permissionCheckBox.usermanagement &&
                                            <FontAwesomeIcon
                                              icon={this.state.openMenu[0] ? faChevronDown : faChevronRight}
                                              style={{ fontSize: "12px", color: "#666" }}
                                              onClick={() => this.toggleMenu(0)}
                                            />}
                                        </div>

                                        {(this.state.openMenu[0] && this.state.permissionCheckBox.usermanagement) && (
                                          <div style={{ paddingLeft: "22px", marginTop: "6px" }}>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="userlist"
                                                value={this.state.permissionCheckBox.userlist}
                                                checked={this.state.permissionCheckBox.userlist}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">User List</label>
                                              {this.state.permissionCheckBox.userlist && <>
                                                <input className="form-check-input ml-4" type="checkbox" name="userlistall" value={this.state.permissionCheckBox.userlistall}
                                                  checked={this.state.permissionCheckBox.userlistall}
                                                  onChange={this.handlePermissionCheckbox} />
                                                <label className="form-check-label ml-5">All</label>
                                              </>}
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="addnewclient"
                                                value={this.state.permissionCheckBox.addnewclient}
                                                checked={this.state.permissionCheckBox.addnewclient}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Add New Client</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="assignplan"
                                                value={this.state.permissionCheckBox.assignplan}
                                                checked={this.state.permissionCheckBox.assignplan}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Assign Plan</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="empreseller"
                                                value={this.state.permissionCheckBox.empreseller}
                                                checked={this.state.permissionCheckBox.empreseller}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Employee/Reseller</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="addeditprice"
                                                value={this.state.permissionCheckBox.addeditprice}
                                                checked={this.state.permissionCheckBox.addeditprice}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Add/Edit Price</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="addeditcredit"
                                                value={this.state.permissionCheckBox.addeditcredit}
                                                checked={this.state.permissionCheckBox.addeditcredit}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Add/Edit Credit</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="transactiondetails"
                                                value={this.state.permissionCheckBox.transactiondetails}
                                                checked={this.state.permissionCheckBox.transactiondetails}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Transaction Details</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="awssetting"
                                                value={this.state.permissionCheckBox.awssetting}
                                                checked={this.state.permissionCheckBox.awssetting}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">AWS Settings</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="billingmode"
                                                value={this.state.permissionCheckBox.billingmode}
                                                checked={this.state.permissionCheckBox.billingmode}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Billing Mode</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="entitybypass"
                                                value={this.state.permissionCheckBox.entitybypass}
                                                checked={this.state.permissionCheckBox.entitybypass}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Entity By Pass</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="changecurrency"
                                                value={this.state.permissionCheckBox.changecurrency}
                                                checked={this.state.permissionCheckBox.changecurrency}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Change Currency</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="bulksmsroutesetting"
                                                value={this.state.permissionCheckBox.bulksmsroutesetting}
                                                checked={this.state.permissionCheckBox.bulksmsroutesetting}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Bulk SMS Route Setting</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="autoshorturl"
                                                value={this.state.permissionCheckBox.autoshorturl}
                                                checked={this.state.permissionCheckBox.autoshorturl}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Auto Short URL</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="extrasetting"
                                                value={this.state.permissionCheckBox.extrasetting}
                                                checked={this.state.permissionCheckBox.extrasetting}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Extra Settings</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="mmlite"
                                                value={this.state.permissionCheckBox.mmlite}
                                                checked={this.state.permissionCheckBox.mmlite}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">MMLite</label>
                                            </div>
                                          </div>
                                        )}
                                      </div>

                                      {/* ===== BOX 2 ===== */}
                                      <div className="col-md-3 mb-3">
                                        <div
                                          className="form-check"
                                          style={{
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                          }}
                                        >
                                          <input className="form-check-input" type="checkbox" name="routemanagement"
                                            value={this.state.permissionCheckBox.routemanagement}
                                            checked={this.state.permissionCheckBox.routemanagement}
                                            onChange={this.handlePermissionCheckbox} />

                                          <label
                                            className="form-check-label"
                                            style={{ fontWeight: "500", marginBottom: 0, color: (this.state.openMenu[1] && this.state.permissionCheckBox.routemanagement) && "#F97316" }}
                                          >
                                            Route Management
                                          </label>

                                          {this.state.permissionCheckBox.routemanagement &&
                                            <FontAwesomeIcon
                                              icon={this.state.openMenu[1] ? faChevronDown : faChevronRight}
                                              style={{ fontSize: "12px", color: "#666" }}
                                              onClick={() => this.toggleMenu(1)}
                                            />}
                                        </div>

                                        {(this.state.openMenu[1] && this.state.permissionCheckBox.routemanagement) && (
                                          <div style={{ paddingLeft: "22px", marginTop: "6px" }}>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="routelist"
                                                value={this.state.permissionCheckBox.routelist}
                                                checked={this.state.permissionCheckBox.routelist}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Route List</label>
                                              {this.state.permissionCheckBox.routelist &&
                                                <>
                                                  <input className="form-check-input ml-4" type="checkbox" name="routelistall" value={this.state.permissionCheckBox.routelistall}
                                                    checked={this.state.permissionCheckBox.routelistall}
                                                    onChange={this.handlePermissionCheckbox} />
                                                  <label className="form-check-label ml-5">All</label>
                                                </>}
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="shiftrouter"
                                                value={this.state.permissionCheckBox.shiftrouter}
                                                checked={this.state.permissionCheckBox.shiftrouter}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Shift Router</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="changeroute"
                                                value={this.state.permissionCheckBox.changeroute}
                                                checked={this.state.permissionCheckBox.changeroute}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Change Route</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="lcrroutesetting"
                                                value={this.state.permissionCheckBox.lcrroutesetting}
                                                checked={this.state.permissionCheckBox.lcrroutesetting}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">LCR Route Setting</label>
                                            </div>
                                          </div>
                                        )}
                                      </div>

                                      {/* ===== BOX 3 ===== */}
                                      <div className="col-md-3 mb-3">
                                        <div
                                          className="form-check"
                                          style={{
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                          }}
                                        >
                                          <input className="form-check-input" type="checkbox" name="embededsignup"
                                            value={this.state.permissionCheckBox.embededsignup}
                                            checked={this.state.permissionCheckBox.embededsignup}
                                            onChange={this.handlePermissionCheckbox} />

                                          <label
                                            className="form-check-label"
                                            style={{ fontWeight: "500", marginBottom: 0, color: (this.state.openMenu[2] && this.state.permissionCheckBox.embededsignup) && "#F97316" }}
                                          >
                                            Embeded Signup
                                          </label>

                                          {this.state.permissionCheckBox.embededsignup &&
                                            <FontAwesomeIcon
                                              icon={this.state.openMenu[2] ? faChevronDown : faChevronRight}
                                              style={{ fontSize: "12px", color: "#666" }}
                                              onClick={() => this.toggleMenu(2)}
                                            />}
                                        </div>

                                        {(this.state.openMenu[2] && this.state.permissionCheckBox.embededsignup) && (
                                          <div style={{ paddingLeft: "22px", marginTop: "6px" }}>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" name="read" type="checkbox"
                                                value={this.state.permissionCheckBox.read}
                                                checked={this.state.permissionCheckBox.read}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Read</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" name="edit" type="checkbox"
                                                value={this.state.permissionCheckBox.edit}
                                                checked={this.state.permissionCheckBox.edit}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Edit</label>
                                            </div>
                                          </div>
                                        )}
                                      </div>

                                      {/* ===== BOX 4 ===== */}
                                      <div className="col-md-3 mb-3">
                                        <div
                                          className="form-check"
                                          style={{
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                          }}
                                        >
                                          <input className="form-check-input" type="checkbox" name="report"
                                            value={this.state.permissionCheckBox.report}
                                            checked={this.state.permissionCheckBox.report}
                                            onChange={this.handlePermissionCheckbox} />

                                          <label
                                            className="form-check-label"
                                            style={{ fontWeight: "500", marginBottom: 0, color: (this.state.openMenu[3] && this.state.permissionCheckBox.report) && "#F97316" }}
                                          >
                                            Report
                                          </label>

                                          {this.state.permissionCheckBox.report &&
                                            <FontAwesomeIcon
                                              icon={this.state.openMenu[3] ? faChevronDown : faChevronRight}
                                              style={{ fontSize: "12px", color: "#666" }}
                                              onClick={() => this.toggleMenu(3)}
                                            />}
                                        </div>

                                        {(this.state.openMenu[3] && this.state.permissionCheckBox.report) && (
                                          <div style={{ paddingLeft: "22px", marginTop: "6px" }}>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="readreport"
                                                value={this.state.permissionCheckBox.readreport}
                                                checked={this.state.permissionCheckBox.readreport}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Read</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="download"
                                                value={this.state.permissionCheckBox.download}
                                                checked={this.state.permissionCheckBox.download}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Download</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="allreport" value={this.state.permissionCheckBox.allreport}
                                                checked={this.state.permissionCheckBox.allreport}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">All Reports</label>
                                            </div>
                                          </div>
                                        )}
                                      </div>

                                      <div className="col-md-3 mb-3">
                                        <div
                                          className="form-check"
                                          style={{
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                          }}
                                        >
                                          <input className="form-check-input" type="checkbox" name="affiliatemanagement"
                                            value={this.state.permissionCheckBox.affiliatemanagement}
                                            checked={this.state.permissionCheckBox.affiliatemanagement}
                                            onChange={this.handlePermissionCheckbox} />

                                          <label
                                            className="form-check-label"
                                            style={{ fontWeight: "500", marginBottom: 0, color: (this.state.openMenu[4] && this.state.permissionCheckBox.affiliatemanagement) && "#F97316" }}
                                          >
                                            Affiliate Management
                                          </label>

                                          {this.state.permissionCheckBox.affiliatemanagement &&
                                            <FontAwesomeIcon
                                              icon={this.state.openMenu[4] ? faChevronDown : faChevronRight}
                                              style={{ fontSize: "12px", color: "#666" }}
                                              onClick={() => this.toggleMenu(4)}
                                            />}
                                        </div>

                                        {(this.state.openMenu[4] && this.state.permissionCheckBox.affiliatemanagement) && (
                                          <div style={{ paddingLeft: "22px", marginTop: "6px" }}>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="affiliateuser"
                                                value={this.state.permissionCheckBox.affiliateuser}
                                                checked={this.state.permissionCheckBox.affiliateuser}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Affiliate Users</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="affiliatecommonlist"
                                                value={this.state.permissionCheckBox.affiliatecommonlist}
                                                checked={this.state.permissionCheckBox.affiliatecommonlist}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Affiliate Common List</label>
                                            </div>
                                          </div>
                                        )}
                                      </div>

                                      <div className="col-md-3 mb-3">
                                        <div
                                          className="form-check"
                                          style={{
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                          }}
                                        >
                                          <input className="form-check-input" type="checkbox" name="useractivity"
                                            value={this.state.permissionCheckBox.useractivity}
                                            checked={this.state.permissionCheckBox.useractivity}
                                            onChange={this.handlePermissionCheckbox} />

                                          <label
                                            className="form-check-label"
                                            style={{ fontWeight: "500", marginBottom: 0, color: (this.state.openMenu[5] && this.state.permissionCheckBox.useractivity) && "#F97316" }}
                                          >
                                            User Activity
                                          </label>

                                          {this.state.permissionCheckBox.useractivity &&
                                            <FontAwesomeIcon
                                              icon={this.state.openMenu[5] ? faChevronDown : faChevronRight}
                                              style={{ fontSize: "12px", color: "#666" }}
                                              onClick={() => this.toggleMenu(5)}
                                            />}
                                        </div>

                                        {(this.state.openMenu[5] && this.state.permissionCheckBox.useractivity) && (
                                          <div style={{ paddingLeft: "22px", marginTop: "6px" }}>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="loginhistory"
                                                value={this.state.permissionCheckBox.loginhistory}
                                                checked={this.state.permissionCheckBox.loginhistory}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Login History</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="signuphistory"
                                                value={this.state.permissionCheckBox.signuphistory}
                                                checked={this.state.permissionCheckBox.signuphistory}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Signup History</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="entityhistory"
                                                value={this.state.permissionCheckBox.entityhistory}
                                                checked={this.state.permissionCheckBox.entityhistory}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Entity History</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="sendorhistory"
                                                value={this.state.permissionCheckBox.sendorhistory}
                                                checked={this.state.permissionCheckBox.sendorhistory}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Sendor History</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="templatehistory"
                                                value={this.state.permissionCheckBox.templatehistory}
                                                checked={this.state.permissionCheckBox.templatehistory}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Template History</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="awssetuphistory"
                                                value={this.state.permissionCheckBox.awssetuphistory}
                                                checked={this.state.permissionCheckBox.awssetuphistory}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">AWS Setup History</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="apirequest"
                                                value={this.state.permissionCheckBox.apirequest}
                                                checked={this.state.permissionCheckBox.apirequest}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">API Request</label>
                                            </div>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="invalidapirequest"
                                                value={this.state.permissionCheckBox.invalidapirequest}
                                                checked={this.state.permissionCheckBox.invalidapirequest}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Invalid API Request</label>
                                            </div>
                                          </div>
                                        )}
                                      </div>

                                      <div className="col-md-3 mb-3">
                                        <div
                                          className="form-check"
                                          style={{
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                          }}
                                        >
                                          <input className="form-check-input" type="checkbox" name="setting"
                                            value={this.state.permissionCheckBox.setting}
                                            checked={this.state.permissionCheckBox.setting}
                                            onChange={this.handlePermissionCheckbox} />

                                          <label
                                            className="form-check-label"
                                            style={{ fontWeight: "500", marginBottom: 0, color: (this.state.openMenu[8] && this.state.permissionCheckBox.setting) && "#F97316" }}
                                          >
                                            Setting
                                          </label>

                                          {this.state.permissionCheckBox.setting &&
                                            <FontAwesomeIcon
                                              icon={this.state.openMenu[8] ? faChevronDown : faChevronRight}
                                              style={{ fontSize: "12px", color: "#666" }}
                                              onClick={() => this.toggleMenu(8)}
                                            />}
                                        </div>

                                        {(this.state.openMenu[8] && this.state.permissionCheckBox.setting) && (
                                          <div style={{ paddingLeft: "22px", marginTop: "6px" }}>
                                            <div className="form-check mb-1">
                                              <input className="form-check-input" type="checkbox" name="resellersetting"
                                                value={this.state.permissionCheckBox.resellersetting}
                                                checked={this.state.permissionCheckBox.resellersetting}
                                                onChange={this.handlePermissionCheckbox} />
                                              <label className="form-check-label">Reseller Setting</label>
                                            </div>
                                          </div>
                                        )}
                                      </div>

                                      <div className="col-md-3 mb-3">
                                        <div
                                          className="form-check"
                                          style={{
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                          }}
                                          onClick={() => this.toggleMenu(11)}
                                        >
                                          <input className="form-check-input" type="checkbox" name="billingreport"
                                            value={this.state.permissionCheckBox.billingreport}
                                            checked={this.state.permissionCheckBox.billingreport}
                                            onChange={this.handlePermissionCheckbox} />

                                          <label
                                            className="form-check-label"
                                            style={{ fontWeight: "500", marginBottom: 0 }}
                                          >
                                            Billing Report
                                          </label>

                                          {this.state.permissionCheckBox.billingreport && <>
                                            <input className="form-check-input ml-8" type="checkbox" name="billingreportall" value={this.state.permissionCheckBox.billingreportall}
                                              checked={this.state.permissionCheckBox.billingreportall}
                                              onChange={this.handlePermissionCheckbox} />
                                            <label className="form-check-label ml-5">All</label>
                                          </>}
                                        </div>
                                      </div>

                                      <div className="col-md-3 mb-3">
                                        <div
                                          className="form-check"
                                          style={{
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                          }}
                                          onClick={() => this.toggleMenu(13)}
                                        >
                                          <input className="form-check-input" type="checkbox" name="vendorsummary"
                                            value={this.state.permissionCheckBox.vendorsummary}
                                            checked={this.state.permissionCheckBox.vendorsummary}
                                            onChange={this.handlePermissionCheckbox} />

                                          <label
                                            className="form-check-label"
                                            style={{ fontWeight: "500", marginBottom: 0 }}
                                          >
                                            Vendor Summary
                                          </label>
                                        </div>
                                      </div>


                                      <div className="col-md-3 mb-3">
                                        <div
                                          className="form-check"
                                          style={{
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                          }}
                                          onClick={() => this.toggleMenu(14)}
                                        >
                                          <input className="form-check-input" type="checkbox" name="encrytionsetting"
                                            value={this.state.permissionCheckBox.encryptionsetting}
                                            checked={this.state.permissionCheckBox.encryptionsetting}
                                            onChange={this.handlePermissionCheckbox} />

                                          <label
                                            className="form-check-label"
                                            style={{ fontWeight: "500", marginBottom: 0 }}
                                          >
                                            Encryption Setting
                                          </label>
                                        </div>
                                      </div>

                                      <div className="col-md-3 mb-3">
                                        <div
                                          className="form-check"
                                          style={{
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                          }}
                                          onClick={() => this.toggleMenu(16)}
                                        >
                                          <input className="form-check-input" type="checkbox" name="notificationsetting"
                                            value={this.state.permissionCheckBox.notificationsetting}
                                            checked={this.state.permissionCheckBox.notificationsetting}
                                            onChange={this.handlePermissionCheckbox} />

                                          <label
                                            className="form-check-label"
                                            style={{ fontWeight: "500", marginBottom: 0 }}
                                          >
                                            Notification Setting
                                          </label>
                                        </div>
                                      </div>

                                      <div className="col-md-3 mb-3">
                                        <div
                                          className="form-check"
                                          style={{
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                          }}
                                          onClick={() => this.toggleMenu(17)}
                                        >
                                          <input className="form-check-input" type="checkbox" name="crossorigin"
                                            value={this.state.permissionCheckBox.crossorigin}
                                            checked={this.state.permissionCheckBox.crossorigin}
                                            onChange={this.handlePermissionCheckbox} />

                                          <label
                                            className="form-check-label"
                                            style={{ fontWeight: "500", marginBottom: 0 }}
                                          >
                                            Cross Origin
                                          </label>
                                        </div>
                                      </div>

                                      <div className="col-md-3 mb-3">
                                        <div
                                          className="form-check"
                                          style={{
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                          }}
                                          onClick={() => this.toggleMenu(18)}
                                        >
                                          <input className="form-check-input" type="checkbox" name="addfaq"
                                            value={this.state.permissionCheckBox.addfaq}
                                            checked={this.state.permissionCheckBox.addfaq}
                                            onChange={this.handlePermissionCheckbox} />

                                          <label
                                            className="form-check-label"
                                            style={{ fontWeight: "500", marginBottom: 0 }}
                                          >
                                            Add FAQ
                                          </label>
                                        </div>
                                      </div>

                                      <div className="col-md-3 mb-3">
                                        <div
                                          className="form-check"
                                          style={{
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                          }}
                                          onClick={() => this.toggleMenu(19)}
                                        >
                                          <input className="form-check-input" type="checkbox" name="blog"
                                            value={this.state.permissionCheckBox.blog}
                                            checked={this.state.permissionCheckBox.blog}
                                            onChange={this.handlePermissionCheckbox} />

                                          <label
                                            className="form-check-label"
                                            style={{ fontWeight: "500", marginBottom: 0 }}
                                          >
                                            Blog
                                          </label>
                                        </div>
                                      </div>

                                      <div className="col-md-3 mb-3">
                                        <div
                                          className="form-check"
                                          style={{
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                          }}
                                          onClick={() => this.toggleMenu(20)}
                                        >
                                          <input className="form-check-input" type="checkbox" name="feedback"
                                            value={this.state.permissionCheckBox.feedback}
                                            checked={this.state.permissionCheckBox.feedback}
                                            onChange={this.handlePermissionCheckbox} />

                                          <label
                                            className="form-check-label"
                                            style={{ fontWeight: "500", marginBottom: 0 }}
                                          >
                                            Feedback
                                          </label>
                                        </div>
                                      </div>

                                      <div className="col-md-3 mb-3">
                                        <div
                                          className="form-check"
                                          style={{
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                          }}
                                          onClick={() => this.toggleMenu(21)}
                                        >
                                          <input className="form-check-input" type="checkbox" name="contactus"
                                            value={this.state.permissionCheckBox.contactus}
                                            checked={this.state.permissionCheckBox.contactus}
                                            onChange={this.handlePermissionCheckbox} />

                                          <label
                                            className="form-check-label"
                                            style={{ fontWeight: "500", marginBottom: 0 }}
                                          >
                                            Contact Us
                                          </label>
                                        </div>
                                      </div>

                                    </div>

                                  </div>
                                </div>}

                              <div className="">
                                <input
                                  type="button"
                                  onClick={() => this.updateEmployedd()}
                                  value="Update Employee Details"
                                  className="btn float-right  btn-primary mt-2"
                                />
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    )}

                    {this.state.rcsPrice && (
                      <div className="card-body">
                        <div className="whatsapp-options">
                          <div className="row">
                            <div className="col-6"></div>
                            <div className="col-6">
                              <label className="switch float-right mb-3">
                                <input
                                  type="checkbox"
                                  defaultChecked={
                                    this.state.isChecked === true
                                      ? "checked"
                                      : null
                                  }
                                  onChange={this.buttonHnadlar}
                                />
                                <span className="slider round"></span>
                              </label>
                              <span className="float-right mr-2">
                                <b>All Country Price</b>
                              </span>
                            </div>
                          </div>
                        </div>
                        {this.state.isChecked ? (
                          <>
                            <div className="row">
                              <div className="col-4">
                                <button
                                  onClick={() =>
                                    this.setState({ showModal: true })
                                  }
                                  className="btn btn-secondary mt-3"
                                  style={{
                                    fontSize: "12px",
                                    padding: "10px 10px 10px 10px",
                                  }}
                                >
                                  <span className="mr-2">
                                    <FontAwesomeIcon icon={faPlus} />
                                  </span>
                                  Add Price
                                </button>
                              </div>
                            </div>
                            {/* <div className="input-group mb-2 mt-4 mr-sm-2">
                                                          <div className="input-group-prepend">
                                                            <div className="input-group-text">AMD CSV File</div>
                                                          </div>
                                                          <input
                                                            type="file"
                                                            name="file"
                                                            accept=".csv"
                                                            onChange={this.handleFileChange}
                                                            className="form-control"
                                                          />
                                                        </div>
                                                        <div className="row">
                                                          <div className="col-6">
                                                          <button type="button" onClick={()=>this.UploadCsv()} className="btn btn-info">Upload</button>
                                                          </div>
                                                        </div> */}
                          </>
                        ) : (
                          <div className="row">
                            <div className="col-md-4">
                              <label className="form-label">County Code</label>
                              <input
                                type="number"
                                defaultValue={this.state.rcscountryCode}
                                onChange={(event) =>
                                  this.setState({
                                    rcscountryCode: event.target.value,
                                    successMessage: false,
                                  })
                                }
                                placeholder="91"
                                className="form-control"
                              />
                            </div>

                            <div className="col-md-4">
                              <label className="form-label">Bot Id</label>
                              <select
                                value={this.state.botid}
                                className="form-control"
                                onChange={(e) =>
                                  this.setState({
                                    botid: e.target.value,
                                    successMessage: false,
                                  })
                                }
                              >
                                <option value={""}>select Bot ID</option>
                                {this.state.userBotId?.map((x) => (
                                  <option value={x.bot_id}>{x.bot_id}</option>
                                ))}
                              </select>
                              {/* <input
                                                            type="text"
                                                            defaultValue={this.state.botid}
                                                            onChange={(event) =>
                                                              this.setState({ botid: event.target.value, successMessage: false })
                                                            }
                                                            placeholder="Rs."
                                                            className="form-control"
                                                          /> */}
                            </div>

                            {!this.state._id && (
                              <div className="col-md-4">
                                <label className="form-label">Margin</label>
                                <input
                                  type="text"
                                  defaultValue={this.state.margin}
                                  onChange={(event) =>
                                    this.setState({
                                      margin: event.target.value,
                                      successMessage: false,
                                    })
                                  }
                                  placeholder="Rs."
                                  className="form-control"
                                />
                              </div>
                            )}

                            {this.state._id ? (
                              <>
                                <div className="col-md-4">
                                  <label className="form-label">
                                    Basic Rcs Cost
                                  </label>
                                  <input
                                    type="text"
                                    defaultValue={this.state.basicrcscost}
                                    onChange={(event) =>
                                      this.setState({
                                        basicrcscost: event.target.value,
                                        successMessage: false,
                                      })
                                    }
                                    placeholder="Rs."
                                    className="form-control"
                                  />
                                </div>
                                <div className="col-md-4">
                                  <label className="form-label">
                                    A2P Single Rcs Cost
                                  </label>
                                  <input
                                    type="text"
                                    defaultValue={
                                      this.state.a2p_single_rcs_cost
                                    }
                                    onChange={(event) =>
                                      this.setState({
                                        a2p_single_rcs_cost: event.target.value,
                                        successMessage: false,
                                      })
                                    }
                                    placeholder="Rs."
                                    className="form-control"
                                  />
                                </div>
                                <div className="col-md-4">
                                  <label className="form-label">
                                    A2P Conversation Cost
                                  </label>
                                  <input
                                    type="text"
                                    defaultValue={
                                      this.state.a2p_conversation_cost
                                    }
                                    onChange={(event) =>
                                      this.setState({
                                        a2p_conversation_cost:
                                          event.target.value,
                                        successMessage: false,
                                      })
                                    }
                                    placeholder="Rs."
                                    className="form-control"
                                  />
                                </div>
                                <div className="col-md-4">
                                  <label className="form-label">
                                    P2A Conversation Cost
                                  </label>
                                  <input
                                    type="text"
                                    defaultValue={
                                      this.state.p2a_conversation_cost
                                    }
                                    onChange={(event) =>
                                      this.setState({
                                        p2a_conversation_cost:
                                          event.target.value,
                                        successMessage: false,
                                      })
                                    }
                                    placeholder="Rs."
                                    className="form-control"
                                  />
                                </div>
                              </>
                            ) : null}
                            {this.state._id && (
                              <div className="col-md-4">
                                <label className="form-label">Status</label>
                                <select
                                  className="form-control"
                                  value={this.state.status}
                                  onChange={(e) =>
                                    this.setState({
                                      status: e.target.value,
                                      successMessage: false,
                                    })
                                  }
                                >
                                  <option value="1">Active</option>
                                  <option value="0">Inactive</option>
                                </select>
                              </div>
                            )}

                            {this.state._id && (
                              <div className="col-md-4">
                                <label className="form-label">Frozen</label>
                                <select
                                  className="form-control"
                                  value={this.state.frozen}
                                  onChange={(e) =>
                                    this.setState({
                                      frozen: e.target.value,
                                      successMessage: false,
                                    })
                                  }
                                >
                                  <option value="1">Frozen</option>
                                  <option value="0">non-Forzen</option>
                                </select>
                              </div>
                            )}

                            <div className="col-md-12 text-right">
                              {this.state._id ? (
                                <div
                                  style={{ marginTop: 40 }}
                                  className="input-group"
                                >
                                  <input
                                    type="button"
                                    onClick={() => this.updateRcsPrice()}
                                    value="Update"
                                    className="btn btn-sm btn-primary text-center"
                                  />
                                </div>
                              ) : (
                                <div
                                  style={{ marginTop: 40 }}
                                  className="input-group text-right"
                                >
                                  <input
                                    type="button"
                                    onClick={() => this.addRcsPrice()}
                                    value="Add"
                                    className="btn btn-sm btn-primary text-center"
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    {this.state.rcsPrice && (
                      <div className="row">
                        <div className="col-12 col-lg-12 col-xxl-12 d-flex">
                          <div className="card table-responsive flex-fill">
                            {this.state.rcsPriceList ? (
                              <table className="table table-hover my-0">
                                <thead>
                                  <tr>
                                    <th>Country Code</th>
                                    <th className="">Bot ID</th>
                                    <th className="">Rcs Cost</th>
                                    <th className="">A2P Sinagle Rcs Cost</th>
                                    <th className="">
                                      {" "}
                                      A2P Conversation Cost{" "}
                                    </th>
                                    <th className="">
                                      {" "}
                                      P2A Conversation Cost{" "}
                                    </th>
                                    <th className=""> Date/Time </th>
                                    {this.state.emp_type ===
                                      "reseller" ? null : (
                                      <>
                                        <th className=""> Edit </th>
                                      </>
                                    )}
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.rcsPriceList.map((item, i) => (
                                    <tr key={i}>
                                      <td>{item.country_code}</td>
                                      <td>{item.bot_id}</td>
                                      <td>{item.basic_sms_cost}</td>
                                      <td>{item.a2p_single_sms_cost}</td>
                                      <td>{item.a2p_conv_cost}</td>
                                      <td>{item.p2a_conv_cost}</td>
                                      <td>
                                        {dayjs(item.created_date).format(
                                          "DD/MM/YYYY h:mm A"
                                        )}
                                      </td>
                                      {this.state.emp_type ===
                                        "reseller" ? null : (
                                        <>
                                          <td>
                                            <span
                                              onClick={() =>
                                                this.getRcsPrice(
                                                  item._id,
                                                  item.country_code,
                                                  item.bot_id,
                                                  item.basic_sms_cost,
                                                  item.a2p_single_sms_cost,
                                                  item.a2p_conv_cost,
                                                  item.p2a_conv_cost
                                                )
                                              }
                                              className="badge bg-success"
                                            >
                                              <FontAwesomeIcon icon={faEdit} />{" "}
                                              Edit
                                            </span>
                                          </td>
                                        </>
                                      )}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            ) : (
                              <div className="text-center">
                                <div className="card-body">
                                  <img
                                    alt="Empty Data"
                                    className="project-empty-img"
                                    src={EmptyImg}
                                  />
                                  <p>No Any User Price Found</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </main>
          <AdminFooter />
        </div>
      </div>
    );
  }
}

export default EditEmployee;
